import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import Grid from '../../../components/layout/Grid';
import Inline, { inlineAlignment } from '../../../components/layout/Inline';
import Button from '../../../components/form/Button';
import Checkbox from '../../../components/form/Checkbox';
import Filter from '../../../components/modal/Filter';

class FilterModal extends Component {
    render() {
        const { open, onClose, anchorEl } = this.props;
        return (
            <Filter open={open} anchorEl={anchorEl} variant="simple" className="popover--filter" onClose={onClose}>
                <Grid container>
                    <Grid item>
                        <h2>Filter</h2>
                        <h3>Status:</h3>
                        <Grid container spacing={1.5}>
                            <Grid item xs={12} md={4}>
                                <Checkbox label="New" />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Checkbox label="Complete" />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Checkbox label="Overdue" />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Checkbox label="In Progress" />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Checkbox label="Urgent" />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Checkbox label="Pending" />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item>
                        <h3>Brand:</h3>
                        <Grid container spacing={1.5}>
                            <Grid item xs={6}>
                                <Checkbox label="Stan Crapp" />
                            </Grid>
                            <Grid item xs={6}>
                                <Checkbox label="MVC" />
                            </Grid>
                            <Grid item xs={6}>
                                <Checkbox label="Nowra Funerals" />
                            </Grid>
                            <Grid item xs={6}>
                                <Checkbox label="Tender Funerals" />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item>
                        <Inline alignment={inlineAlignment.right}>
                            <Button
                                onClick={() => this.setState({ showFilterModal: false })}
                                variant="modal-action modal-action--cancel"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={() => this.setState({ showFilterModal: false })}
                                variant="modal-action modal-action--ok"
                            >
                                Ok
                            </Button>
                        </Inline>
                    </Grid>
                </Grid>
            </Filter>
        );
    }
}

export default withStyles({})(FilterModal);
